import { z } from 'zod';
import { TypeOfAPIError, TypeOfAPIResponse } from '@ninja/api-client';
import { APIFactoryOptions, factory } from '../../../config';

const pagingSchema = z.object({
	pageSize: z.number(),
	pageNumber: z.number(),
});

const sortingSchema = z.object({
	columnName: z.string(),
	sortOrder: z.number(),
});

const requestSchema = z.object({
	paging: pagingSchema,
	sorting: sortingSchema,
	facilityTypeIds: z.array(z.number()).optional(),
	cityIds: z.array(z.number()).optional(),
	countryIds: z.array(z.number()).optional(),
	facilityName: z.string().optional(),
});

const responseSchema = z.object({
	network: z.array(
		z.object({
			cityId: z.number(),
			facilityName: z.string(),
			facilityTypeId: z.number(),
			facilityRegion: z.string(),
		})
	),
	paging: z.object({
		totalRecords: z.number(),
	}),
});

const getNetworkList = (options: APIFactoryOptions) =>
	factory(options).createAPIDefinition({
		url: '/admin/plan/networksearch',
		method: 'POST',
		responseSchema,
		requestSchema,
		requestParameters: { planId: ['required', 'number'] },
	});

export default getNetworkList;

export type NetworkAdminListRequest = z.infer<typeof requestSchema>;

export type NetworkAdminListResponse = TypeOfAPIResponse<ReturnType<typeof getNetworkList>>;

export type NetworkAdminListError = TypeOfAPIError<ReturnType<typeof getNetworkList>>;
